export default "__VITE_ASSET__rUY4xUv4__"